// extracted by mini-css-extract-plugin
export default {"shadowed":"Home_shadowed__NM6OV","hand":"Home_hand__xtomW","wave":"Home_wave__rWGEL"};